// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__UoA9G","cardTitle":"Card_cardTitle__t51Mx","cardContent":"Card_cardContent__jQ4B5"};